<div class="ui stackable grid">
  <div class="sixteen wide column">
    <app-power-bi-dashboard></app-power-bi-dashboard>
  </div>
</div>
